import { Colors } from 'basic-ui-lib/constants';
import { ConfigProvider, Input as InputAnt, InputProps } from 'antd';
import styled from 'styled-components';

const BaseInput = (props: InputProps) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          controlHeight: 48,
          borderRadius: 5,
        },
        components: {
          Input: {
            colorBorder: Colors.neutral.border[3],
            activeBorderColor: Colors.primary[6],
            hoverBorderColor: Colors.primary[6],
            fontSize: 14,
            fontFamily: 'Poppins',
            colorText: Colors.neutral.text[5],
            fontWeightStrong: 500,
            colorTextPlaceholder: Colors.neutral.text[4],
          },
        },
      }}
    >
      <StyledInput {...props} />
    </ConfigProvider>
  );
};

export default BaseInput;

const StyledInput = styled(InputAnt)`
  width: 100%;
  font-weight: 500;

  .ant-input-prefix {
    margin-right: 10px;
  }
  
  .ant-input {
    font-weight: 500;
  }
`;
